export default __webpack_public_path__ + "static/media/dealer.63146147.svg";